import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from 'environments/environment';
import { SessionService } from 'app/services/session.service';

export const adminProdGuard = () => {
    const session = inject(SessionService);
    const router = inject(Router);

    if (environment.name === 'prod' && session.user.isAdmin) {
        return true;
    }

    return router.parseUrl('/');
};
